import type { AuthUiMessage } from '@/shared/auth/authUiMessages';

type KickoutFrom = {
  pathname: string;
  search?: string;
  hash?: string;
};

export type AuthKickoutState = {
  message: AuthUiMessage;
  from: KickoutFrom;
  at: number;
};

const KEY = 'pacmaster:auth:kickout';

function canUseSessionStorage(): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
  } catch {
    return false;
  }
}

export function setAuthKickoutState(state: AuthKickoutState) {
  if (!canUseSessionStorage()) return;
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    // ignore
  }
}

export function getAuthKickoutState(): AuthKickoutState | null {
  if (!canUseSessionStorage()) return null;
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<AuthKickoutState>;

    const msg = parsed?.message as any;
    const from = parsed?.from as any;
    const at = parsed?.at;

    if (!msg || (typeof msg.title !== 'string' && typeof msg.description !== 'string')) return null;
    if (!from || typeof from.pathname !== 'string') return null;
    if (typeof at !== 'number') return null;

    return {
      message: {
        title: String(msg.title || 'Sign-in required'),
        description: String(msg.description || 'Please sign in again.'),
      },
      from: {
        pathname: String(from.pathname),
        search: typeof from.search === 'string' ? from.search : '',
        hash: typeof from.hash === 'string' ? from.hash : '',
      },
      at,
    };
  } catch {
    return null;
  }
}

export function clearAuthKickoutState() {
  if (!canUseSessionStorage()) return;
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
